import { render, staticRenderFns } from "./TagTriggersSettingsModal.vue?vue&type=template&id=471fde4a&"
import script from "./TagTriggersSettingsModal.vue?vue&type=script&lang=js&"
export * from "./TagTriggersSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./TagTriggersSettingsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports